import * as React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import VideoPlayer from '../../../../components/videoPlayer'
import { QuestionState } from '../../../../features/types'

interface Props {
    question: QuestionState
    open: boolean
    confirmAction: () => void
    handleClose: () => void
}

const VideoExplanationDialog: React.FC<Props> = ({
    question,
    confirmAction,
    open,
    handleClose,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Dialog
            maxWidth={'md'}
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogContent>
                <VideoPlayer link={question.videoLink} />
            </DialogContent>

            <DialogActions sx={{ m: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => {
                        confirmAction()
                        handleClose()
                    }}
                >
                    {formatMessage({ id: 'ok' })}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default VideoExplanationDialog
